import { ReactNode } from 'react';
import {
  PrimaryDetailsPanelColumnTitle,
  PrimaryDetailsPanelColumnValue,
  PrimaryDetailsPanelColumnWrapper,
} from './styles';

type PrimaryDetailsPanelColumnType = {
  name?: ReactNode;
  title?: string;
  ratio?: string;
  children?: ReactNode;
};

export const PrimaryDetailsPanelColumn = ({ name, title, ratio, children }: PrimaryDetailsPanelColumnType) => {
  return (
    <PrimaryDetailsPanelColumnWrapper ratio={ratio}>
      <PrimaryDetailsPanelColumnTitle>{name}</PrimaryDetailsPanelColumnTitle>
      <PrimaryDetailsPanelColumnValue title={title}>{children}</PrimaryDetailsPanelColumnValue>
    </PrimaryDetailsPanelColumnWrapper>
  );
};
